module.exports = __webpack_public_path__ + "img/woman-torso-front.f108641c.png";